/** Espelha public.origem_lancamento (db_compras) e `OrigemLancamentoEnum` da API Compras: de onde vêm os valores do lançamento. */
export enum OrigemLancamentoEnum {
  NotaFiscal = 1,
  Pedido = 2,
}
